// removed by extract-text-webpack-plugin
module.exports = {"Container":"lightTextInput__Container__2UxBm","Input":"lightTextInput__Input__ZarOv","Label":"lightTextInput__Label__396LD","Hover":"lightTextInput__Hover__2Waex"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Form/TextInput/lightTextInput.css
// module id = 884
// module chunks = 2